import styles from "./IconPicker.module.scss";
import React, {useState} from "react";
import clsx from "clsx";
import ClickAwayListener from "react-click-away-listener";

export const ICONS = [
  "trending_up",
  "euro",
  "local_gas_station",
  "local_taxi",
  "local_parking",
  "real_estate_agent",
  "construction",
  "child_care",
  "child_friendly",
  "phone",
  "atm",
  "receipt_long",
  "restaurant",
  "subscriptions",
  "savings",
  "build",
  "build_circle",
  "other_houses",
  "home",
  "shopping_cart",
  "favorite",
  "description",
  "face",
  "free_breakfast",
  "electric_bolt",
  "event",
  "paid",
  "shopping_bag",
  "lightbulb",
  "credit_card",
  "account_balance",
  "fact_check",
  "assignment",
  "account_balance_wallet",
  "work",
  "store",
  "pets",
  "flight_takeoff",
  "gavel",
  "cake",
  "self_improvement",
  "sports_soccer",
  "local_shipping",
  "flight",
  "fastfood",
  "home_repair_service",
  "hotel",
  "local_bar",
];

export const IconPicker = ({value, onChange}) => {
  const [iconsShown, setIconsShown] = useState(false);

  const chooseIcon = icon => {
    onChange(icon);

    setIconsShown(false);
  };

  return <ClickAwayListener onClickAway={() => setIconsShown(false)}>
    <div className={styles.iconPicker}>
      <div className={styles.currentValue} onClick={() => setIconsShown(prev => !prev)}>
        <div className={styles.icon}><span className="material-icons">{value}</span></div>

        <span className="material-icons">arrow_drop_down</span>
      </div>

      <div className={clsx(styles.icons, iconsShown ? styles.show : null)}>
        {ICONS.map(icon => <span key={icon} className="material-icons" onClick={() => chooseIcon(icon)}>{icon}</span>)}
      </div>
    </div>
  </ClickAwayListener>;
};
